import { render, staticRenderFns } from "./mailings_manager.vue?vue&type=template&id=6e4ed3b7&"
import script from "./mailings_manager.vue?vue&type=script&lang=js&"
export * from "./mailings_manager.vue?vue&type=script&lang=js&"
import style0 from "./mailings_manager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e4ed3b7')) {
      api.createRecord('6e4ed3b7', component.options)
    } else {
      api.reload('6e4ed3b7', component.options)
    }
    module.hot.accept("./mailings_manager.vue?vue&type=template&id=6e4ed3b7&", function () {
      api.rerender('6e4ed3b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mailings/mailings_manager.vue"
export default component.exports